import { useScreenSize } from '@hooks';
import { Button, Flex, theme, Typography } from '@styles';
import { bool, func, number } from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

const TestFinishCard = ({
  correctAnswers,
  handleShowAnswers,
  isPassed,
  isValidated,
  totalAnswers,
}) => {
  const { isTabletSM } = useScreenSize();
  const { i18n } = useTranslation();

  return (
    <Flex alignItems="center" flexDirection="column" gap={24} width="100%">
      <Flex
        alignItems="center"
        backgroundColor={theme.colors.hunterGreen[90]}
        borderColor={theme.colors.whiteLine[100]}
        borderStyle="solid"
        borderWidth={1}
        flexDirection="column"
        height={392}
        py={80}
        width="100%"
      >
        {isValidated ? (
          <>
            <Typography
              color={theme.colors.white[100]}
              mb={18}
              textAlign="center"
              variant={isTabletSM ? 'BN-bold-s56-lh67' : 'BN-bold-s123-lh104'}
            >
              {i18n.t(`TestPage.${isPassed ? 'Pass' : 'Fail'}`).toUpperCase()}
            </Typography>
            <Typography
              color={theme.colors.white[60]}
              mb={16}
              variant={
                isTabletSM ? 'MS-regular-s18-lh28' : 'MS-regular-s24-lh37'
              }
            >
              {i18n.t('TestPage.CorrectAnswers')}: {correctAnswers}/
              {totalAnswers}
            </Typography>
            {handleShowAnswers && (
              <Button
                onClick={handleShowAnswers}
                variant="textButton"
                width={240}
              >
                <Typography
                  color={theme.colors.schoolBusYellow[100]}
                  variant="MS-semibold-s16-lh17"
                >
                  {i18n.t('TestPage.ShowAnswers').toUpperCase()}
                </Typography>
              </Button>
            )}
          </>
        ) : (
          <Flex
            alignItems="center"
            flex={1}
            flexDirection="column"
            gap={18}
            justifyContent="center"
            width="80%"
          >
            <Typography
              color={theme.colors.white[100]}
              textAlign="center"
              variant={isTabletSM ? 'MS-regular-s24-lh37' : 'BN-bold-s56-lh67'}
            >
              {i18n.t('TestPage.YouPassed')}
            </Typography>
            <Typography
              color={theme.colors.white[60]}
              textAlign="center"
              variant={
                isTabletSM ? 'MS-regular-s18-lh28' : 'MS-regular-s24-lh37'
              }
            >
              {i18n.t('TestPage.Continue')}
            </Typography>
          </Flex>
        )}
      </Flex>
      {!isPassed && isValidated && (
        <Flex
          backgroundColor={theme.colors.white[10]}
          justifyContent="center"
          p={12}
          width="100%"
        >
          <Typography
            color={theme.colors.white[60]}
            variant={isTabletSM ? 'MS-regular-s18-lh28' : 'MS-regular-s24-lh28'}
          >
            {i18n.t('TestPage.SpendTime')}
          </Typography>
        </Flex>
      )}
    </Flex>
  );
};

TestFinishCard.propTypes = {
  correctAnswers: number.isRequired,
  handleShowAnswers: func,
  isPassed: bool.isRequired,
  isValidated: bool.isRequired,
  totalAnswers: number.isRequired,
};

TestFinishCard.defaultProps = {
  handleShowAnswers: null,
};

export default TestFinishCard;
